export default "__VITE_ASSET__D_i1v3pa__"